import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { call } from "redux-saga/effects";

const GET = "GET";
const POST = "POST";

interface ApiCallOptions {
  token?: string;
  [key: string]: any;
}

interface Headers {
  [key: string]: string;
}

function* callApi(
  url: string,
  path: string,
  method: string,
  options: ApiCallOptions = {},
  headers: Headers = {}
) {
  let token: string | null = null;

  const to = `${url}${path}`;
  const axiosConfig: AxiosRequestConfig = { method, url: to };

  if (headers) {
    axiosConfig.headers = { ...headers }; // Clone headers if present
  } else {
    axiosConfig.headers = {}; // Initialize headers if not present
  }

  if (options.token || token) {
    axiosConfig.headers["x-access-token"] = options.token || token;
    delete options.token;
  }

  axiosConfig[method === "GET" ? "params" : "data"] = options;

  const result: AxiosResponse<any> = yield call(axios as any, axiosConfig);
  return result;
}

export function* apiGet(
  api: string,
  to: string,
  params: ApiCallOptions = {},
  headers: Headers = {}
): any {
  return yield call(callApi, process.env[api] || "", to, GET, params, headers);
}

export function* apiPost(
  api: string,
  to: string,
  params: ApiCallOptions = {},
  headers: Headers = {}
): any {
  return yield call(callApi, process.env[api] || "", to, POST, params, headers);
}
